import { render } from "./FixLanguageStringErrors.vue?vue&type=template&id=61e4b631&scoped=true"
import script from "./FixLanguageStringErrors.vue?vue&type=script&lang=js"
export * from "./FixLanguageStringErrors.vue?vue&type=script&lang=js"

import "./FixLanguageStringErrors.vue?vue&type=style&index=0&id=61e4b631&lang=scss&scoped=true"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e4b631"]])

export default __exports__